import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#text-input-dialog-toolbar"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const TextInputDialog = ({ prompt, onConfirm, onClose }) => {
    const [value, setValue] = useState("");

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    const lines = prompt?.message?.split('\n');

    return (
        <Dialog
            open={prompt !== null}
            onClose={onClose}
            fullWidth={400}
            PaperProps={{
                component: 'form',
                onSubmit: (event) => {
                    event.preventDefault();
                    onConfirm(value);
                },
            }}
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)", // Darker backdrop
                },
            }}
        >
            <DialogTitle sx={{ cursor: 'move' }} id="text-input-dialog-toolbar">{prompt?.title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {lines?.map((line, index) => (
                        <Typography key={index} gutterBottom>{line}</Typography>
                    ))}
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="name"
                    name="email"
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button type="submit">Confirm</Button>
                <Button onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default TextInputDialog;
